<template>
    <v-card>
        <v-toolbar color="primary" dark flat class="pl-0 ml-0">
                <v-icon @click="previous_student">chevron_left</v-icon>
                <v-btn icon>
                    <v-icon @click="link_dialog = true">person</v-icon>
                </v-btn>
                <v-icon @click="next_student">chevron_right</v-icon>
                <v-toolbar-title @click="link_dialog = true" class="hover_pointer">
                    <span class="pl-4">{{ student.first_name }} {{ student.last_name }}</span>
                </v-toolbar-title>
                <v-dialog v-model="link_dialog" max-width="450">
                    <v-card class="pt-5 pl-7 pr-7 ma-0">
                        <v-text-field single-line label="link" dense :value="link" class="mt-2 mr-0 ml-0 mb-0 pa-0" outlined prepend-inner-icon="link" readonly @focus="$event.target.select()" @click="$event.target.select()"/>
                    </v-card>
                </v-dialog>
            <v-spacer></v-spacer><v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-tabs v-model="tabs" :vertical="false && !$vuetify.breakpoint.xs" :fixed-tabs="true || $vuetify.breakpoint.xs">
            <v-tab><v-icon :left="!$vuetify.breakpoint.xs">event</v-icon><span v-if="!$vuetify.breakpoint.xs">Events</span><v-spacer v-if="false && !$vuetify.breakpoint.xs"></v-spacer></v-tab>
            <v-tab><v-icon :left="!$vuetify.breakpoint.xs">directions_run</v-icon><span v-if="!$vuetify.breakpoint.xs">Trainers</span><v-spacer v-if="false && !$vuetify.breakpoint.xs"></v-spacer></v-tab>
            <v-tab><v-icon :left="!$vuetify.breakpoint.xs">content_paste</v-icon><span v-if="!$vuetify.breakpoint.xs">Assignments</span><v-spacer v-if="false && !$vuetify.breakpoint.xs"></v-spacer></v-tab>
            <v-tab-item>
                <v-row class="ma-0 pa-0">
                <v-list two-line>
                    <v-subheader v-if="(future_events + current_events).length == 0"><i>No events</i></v-subheader>
                    <v-subheader v-if="current_events && current_events.length > 0">Current</v-subheader>
                    <v-list-item v-for="ev in current_events" :key="ev.start_date">
                            <v-list-item-avatar>
                                <v-hover v-slot:default="{ hover }">
                                    <v-avatar fab size="40" depressed :color="ev.creator.color">
                                        <v-icon v-show="!hover" v-text="ev.type.icon"></v-icon>
                                        <span
                                          v-show="hover">{{ (ev.creator.first_name[0] + ev.creator.last_name[0]).toUpperCase() }}</span>
                                    </v-avatar>
                                </v-hover>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="ev.name"></v-list-item-title>
                                <v-list-item-subtitle><i>{{ Math.abs(Math.floor( (Date.parse(ev.end_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d left</i></v-list-item-subtitle>
                            </v-list-item-content>
                    </v-list-item>
                    <v-subheader v-if="future_events && future_events.length > 0">Upcoming</v-subheader>
                    <v-list-item v-for="ev in future_events" :key="ev.start_date">
                            <v-list-item-avatar>
                                <v-hover v-slot:default="{ hover }">
                                    <v-avatar size="40" depressed :color="ev.creator.color">
                                        <v-icon v-show="!hover" v-text="ev.type.icon"></v-icon>
                                        <span
                                          v-show="hover">{{ (ev.creator.first_name[0] + ev.creator.last_name[0]).toUpperCase() }}</span>
                                    </v-avatar>
                                </v-hover>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="ev.name"></v-list-item-title>
                                <v-list-item-subtitle><i>in {{ Math.abs(Math.floor( (Date.parse(ev.start_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d</i></v-list-item-subtitle>
                            </v-list-item-content>
                    </v-list-item>
                </v-list>
                </v-row>
            </v-tab-item>
            <v-tab-item>
                <v-row class="ma-0 pa-0">
                    <v-list style="width: 100%">
                        <v-subheader>Main</v-subheader>
                        <trainer-picker :trainer="student.trainer" :student="student"/>
                        <v-subheader>Secondary</v-subheader>
                        <trainer-picker secondary :disabled="student.trainer == null" :trainer="student.secondary_trainer" :student="student"/>
                    </v-list>
                </v-row>
            </v-tab-item>
            <v-tab-item>
                <v-row class="ma-0 pt-5 pb-5 px-0">
                    <lesson-assignment-list :student_id="student.id" style="width: 100%"/>
                </v-row>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import TrainerPicker from './TrainerPicker.vue'
import LessonAssignmentList from './LessonAssignmentList.vue'

export default {
    name: 'StudentDialog',
    components: {
        TrainerPicker,
        LessonAssignmentList
    },
    props: {
        mode: String,
        student_id: Number
    },
    data () {
        return {
            trainer_mockup: false,
            link_dialog: false,
            tabs: this.mode == 'events' ? 0 : 1,
        }
    },
    computed: {
        student () {
            return this.$store.getters['teacher/students'].find(s => s.id == this.student_id);
        },
        link () {
            return 'https://' + location.host + '/student/' + this.student.hash;
        },
        current_events () {
            return this.student.events.filter(e => (Date.parse(e.start_date) - Date.now() <= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        },
        future_events () {
            return this.student.events.filter(e => (Date.parse(e.start_date) - Date.now() >= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        }
    },
    methods: {
        next_student () {
            var current_idx = this.$store.getters['teacher/students'].findIndex(s => s.id == this.student_id);
            var next_idx = (current_idx + 1) % this.$store.getters['teacher/students'].length;
            var next_id = this.$store.getters['teacher/students'][next_idx].id;
            this.$emit('change-student', next_id);
        },
        previous_student () {
            var current_idx = this.$store.getters['teacher/students'].findIndex(s => s.id == this.student_id);
            var next_idx = (current_idx - 1 + this.$store.getters['teacher/students'].length) % this.$store.getters['teacher/students'].length;
            var next_id = this.$store.getters['teacher/students'][next_idx].id;
            this.$emit('change-student', next_id);
        },
    },
    async mounted () {
        if (this.$store.getters['teacher/trainers'].length == 0) {
            await this.$store.dispatch('teacher/get_trainers');
        }
    }
}

</script>

<style>
.hover_pointer:hover {
    cursor: pointer;
}
</style>
